import Vue from 'vue';

Vue.config.devtools = false
Vue.config.productionTip = false

import store from './vue/store'
import NameSlug from './vue/NameSlug.vue';
import AddBlock from './vue/AddBlock.vue';
import SortPrivacy from './vue/SortPrivacy.vue';

import { axios } from "./vue/helpers"
window.axios = axios

const app = new Vue({
    el: '#app',
    store: store,
    components: {
        NameSlug,
        AddBlock,
        SortPrivacy,
    }
});
